module.exports = __webpack_public_path__ + "img/hj5.7b4bc809.jpg";